import { Navigate } from "react-router-dom";

import Login from "../pages/Login";
import Logout from "../pages/Logout";

import Dashboard from "../pages/Dashboard";
import Payments from "../pages/Payments";
import SpareParts from "../pages/SpareParts";
import Customer from "../pages/Customers";

export const authRoutes = [
  { path: "/", title: "Dashboard", component: <Dashboard /> },

  { path: "/payments", title: "Payments", component: <Payments /> },
  { path: "/parts", title: "Spare Parts", component: <SpareParts /> },
  { path: "/customers", title: "Customer", component: <Customer /> },
  // { path: "/accounts", title: "Accounts", component: <Accounts /> },
  // { path: "/transfer", title: "Transfer", component: <Transfer /> },

  { path: "/logout", title: "Log out", component: <Logout /> },

  { path: "*", component: <Navigate to="/" /> },
];
export const nonAuthRoutes = [{ path: "/login", component: <Login />, title: "Login" }];
